import { useSelector } from "react-redux";
import type { FieldConfiguration } from "../../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { ReportField } from "../../../../../../../../../../api/types/svTypes.ts";
import { ReportType } from "../../../../../../../../../../api/types/svTypes.ts";
import { selectCurrentReportType } from "../../../../../../store/selectors/currentReportSelectors";
import SwitchMenuItem from "../../../../common/fields/field-options/SwitchMenuItem.tsx";

interface Props {
  field: ReportField;
  saveChanges: (changes: Partial<FieldConfiguration>, causeClosing: boolean) => void;
  readonly: boolean;
}

export default function PivotFieldMenuItem(props: Props) {
  const { field, saveChanges, readonly } = props;
  const reportType = useSelector(selectCurrentReportType);

  if (reportType !== ReportType.Pivot) return <></>;

  return (
    <SwitchMenuItem
      caption="Pivot Field"
      value={!field.config.standalone}
      onClick={() => saveChanges({ standalone: !field.config.standalone }, false)}
      disabled={readonly}
    />
  );
}
